<script setup lang="ts">
import {nextTick, ref} from "vue";

let player: Aliplayer;
const visible = ref(false);
const videoUrl = ref("")

const initVideoPlayer = async () => {
  await nextTick()
  const options: PlayerOption = {
    id: "player-con",
    width: "100%",
    autoplay: true,
    source: videoUrl.value,
  };
  player = new Aliplayer(options);
}

const disposeVideo = () => {
  if (player) {
    player.dispose();
  }
}

const show = (_videoUrl: string) => {
  videoUrl.value = _videoUrl
  visible.value = true;
  initVideoPlayer()
}

const hide = () => {
  visible.value = false;
}

const onClose = () => {
  disposeVideo()
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog v-model="visible" width="40%"  align-center title="视频播放" @close="onClose">
    <div id="player-con" ref="playerCon">
    </div>
  </el-dialog>
</template>

<style scoped>
</style>
